export default __webpack_public_path__ + "static/media/info-circle.357d9b6c.svg";